import React from 'react';
import CompFooter from '@/components/ReolinkFooter';
import gdpr from '@reolink-web/gdpr-cookies';
import '@reolink-web/gdpr-cookies/dist/style.css';
import type { IMultiSiteStoreFetchRes } from './fetch';
import { GBAndEUCountriesSet } from '@/data/constant';

const CompFooterEntry: React.FC<{ ctx: IMultiSiteStoreFetchRes; }> = React.memo((props) => {
    React.useEffect(() => {
        const ONLY_SHOW_GDPR_ON_USER_CLICK_COUNTRY = 'US';
        const currentCountry = props.ctx.country;
        if (GBAndEUCountriesSet.has(currentCountry) || currentCountry === ONLY_SHOW_GDPR_ON_USER_CLICK_COUNTRY) {
            gdpr.init(currentCountry, props.ctx.lang, currentCountry !== ONLY_SHOW_GDPR_ON_USER_CLICK_COUNTRY);
        }
    }, [props.ctx.country, props.ctx.lang]);

    return <CompFooter { ...props }></CompFooter>;
});

export default CompFooterEntry;
